export class CfResponse {
  private _data: any;
  private _status: number;

  // 基本方針はcf-baseの戻り値と同じものとする。
  // xhrは取得できそうにないので、返却しない。
  // tslint:disable-next-line:max-line-length
  constructor(data: {}, status: number) {
    this._data = data;
    this._status = status;
  }

  get data() {
    return this._data;
  }

  get status() {
    return this._status;
  }
}
